import React, { useEffect, useState } from "react";
import { PageHeader, Loader, Badge, Empty } from "@/components/shared";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { fmtPKR, fmtDate, statusColor } from "@/lib/format";

export default function AdminPredictions() {
  const { t } = useI18n();
  const [preds, setPreds] = useState(null);
  useEffect(() => { api.get("/admin/predictions").then(({ data }) => setPreds(data)).catch(() => {}); }, []);
  if (!preds) return <Loader />;

  return (
    <div>
      <PageHeader title={t("all_predictions")} subtitle={`${preds.length} total predictions`} />
      {preds.length === 0 ? <Empty label="No predictions yet." /> : (
        <div className="ec-card overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-gray-500 border-b border-white/10">
              {["Member", "Event", t("selected_team"), t("amount"), t("reward_amount"), t("status"), "Date"].map((h) => <th key={h} className="text-start font-semibold px-4 py-3">{h}</th>)}
            </tr></thead>
            <tbody>
              {preds.map((p) => (
                <tr key={p.id} className="border-b border-white/5" data-testid={`allpred-${p.prediction_id}`}>
                  <td className="px-4 py-3 text-white">{p.user_name}</td>
                  <td className="px-4 py-3 text-gray-400">{p.event_name}</td>
                  <td className="px-4 py-3 text-orange-400 font-semibold">{p.selected_team}</td>
                  <td className="px-4 py-3 text-gray-200">{fmtPKR(p.amount)}</td>
                  <td className="px-4 py-3 text-emerald-400">{fmtPKR(p.reward_amount)}</td>
                  <td className="px-4 py-3"><Badge className={statusColor(p.status)}>{p.status}</Badge></td>
                  <td className="px-4 py-3 text-gray-500">{fmtDate(p.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
